// extracted by mini-css-extract-plugin
module.exports = {"root":"Card_root__1LHl3","title":"Card_title__dvXbo"};